/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BookingDto } from '../models/booking-dto';
import { BookingWidgetTimelineDto } from '../models/booking-widget-timeline-dto';
import { BookingWidgetTotalDto } from '../models/booking-widget-total-dto';
import { cloneBooking } from '../fn/admin-bookings-api/clone-booking';
import { CloneBooking$Params } from '../fn/admin-bookings-api/clone-booking';
import { createShare1 } from '../fn/admin-bookings-api/create-share-1';
import { CreateShare1$Params } from '../fn/admin-bookings-api/create-share-1';
import { deleteShare2 } from '../fn/admin-bookings-api/delete-share-2';
import { DeleteShare2$Params } from '../fn/admin-bookings-api/delete-share-2';
import { getActiveBooking } from '../fn/admin-bookings-api/get-active-booking';
import { GetActiveBooking$Params } from '../fn/admin-bookings-api/get-active-booking';
import { getBooking } from '../fn/admin-bookings-api/get-booking';
import { GetBooking$Params } from '../fn/admin-bookings-api/get-booking';
import { getBookingLogs1 } from '../fn/admin-bookings-api/get-booking-logs-1';
import { GetBookingLogs1$Params } from '../fn/admin-bookings-api/get-booking-logs-1';
import { getBookings } from '../fn/admin-bookings-api/get-bookings';
import { GetBookings$Params } from '../fn/admin-bookings-api/get-bookings';
import { getBookingShareLogs1 } from '../fn/admin-bookings-api/get-booking-share-logs-1';
import { GetBookingShareLogs1$Params } from '../fn/admin-bookings-api/get-booking-share-logs-1';
import { getBookingShares2 } from '../fn/admin-bookings-api/get-booking-shares-2';
import { GetBookingShares2$Params } from '../fn/admin-bookings-api/get-booking-shares-2';
import { getBookingsWidgetTimeline } from '../fn/admin-bookings-api/get-bookings-widget-timeline';
import { GetBookingsWidgetTimeline$Params } from '../fn/admin-bookings-api/get-bookings-widget-timeline';
import { getBookingsWidgetTotal } from '../fn/admin-bookings-api/get-bookings-widget-total';
import { GetBookingsWidgetTotal$Params } from '../fn/admin-bookings-api/get-bookings-widget-total';
import { PageDtoBookingBookingDto } from '../models/page-dto-booking-booking-dto';
import { PageDtoBookingLogBookingLogDto } from '../models/page-dto-booking-log-booking-log-dto';
import { ShareDto } from '../models/share-dto';
import { terminateBooking1 } from '../fn/admin-bookings-api/terminate-booking-1';
import { TerminateBooking1$Params } from '../fn/admin-bookings-api/terminate-booking-1';
import { updateBookingPin1 } from '../fn/admin-bookings-api/update-booking-pin-1';
import { UpdateBookingPin1$Params } from '../fn/admin-bookings-api/update-booking-pin-1';
import { updateShare1 } from '../fn/admin-bookings-api/update-share-1';
import { UpdateShare1$Params } from '../fn/admin-bookings-api/update-share-1';

@Injectable({ providedIn: 'root' })
export class AdminBookingsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateBookingPin1()` */
  static readonly UpdateBookingPin1Path = '/api/admin/bookings/{id}/updatePin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBookingPin1()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBookingPin1$Response(params: UpdateBookingPin1$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return updateBookingPin1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBookingPin1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBookingPin1(params: UpdateBookingPin1$Params, context?: HttpContext): Observable<BookingDto> {
    return this.updateBookingPin1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `terminateBooking1()` */
  static readonly TerminateBooking1Path = '/api/admin/bookings/{id}/terminate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `terminateBooking1()` instead.
   *
   * This method doesn't expect any request body.
   */
  terminateBooking1$Response(params: TerminateBooking1$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return terminateBooking1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `terminateBooking1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  terminateBooking1(params: TerminateBooking1$Params, context?: HttpContext): Observable<BookingDto> {
    return this.terminateBooking1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `updateShare1()` */
  static readonly UpdateShare1Path = '/api/admin/bookings/{id}/shares/{shareId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateShare1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateShare1$Response(params: UpdateShare1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return updateShare1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateShare1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateShare1(params: UpdateShare1$Params, context?: HttpContext): Observable<ShareDto> {
    return this.updateShare1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `deleteShare2()` */
  static readonly DeleteShare2Path = '/api/admin/bookings/{id}/shares/{shareId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteShare2()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteShare2$Response(params: DeleteShare2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteShare2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteShare2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteShare2(params: DeleteShare2$Params, context?: HttpContext): Observable<void> {
    return this.deleteShare2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `cloneBooking()` */
  static readonly CloneBookingPath = '/api/admin/bookings/{id}/clone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cloneBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  cloneBooking$Response(params: CloneBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return cloneBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cloneBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cloneBooking(params: CloneBooking$Params, context?: HttpContext): Observable<BookingDto> {
    return this.cloneBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `getBookingShares2()` */
  static readonly GetBookingShares2Path = '/api/admin/bookings/{id}/shares';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingShares2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShares2$Response(params: GetBookingShares2$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareDto>>> {
    return getBookingShares2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingShares2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShares2(params: GetBookingShares2$Params, context?: HttpContext): Observable<Array<ShareDto>> {
    return this.getBookingShares2$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ShareDto>>): Array<ShareDto> => r.body)
    );
  }

  /** Path part for operation `createShare1()` */
  static readonly CreateShare1Path = '/api/admin/bookings/{id}/shares';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createShare1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createShare1$Response(params: CreateShare1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return createShare1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createShare1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createShare1(params: CreateShare1$Params, context?: HttpContext): Observable<ShareDto> {
    return this.createShare1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `getBookings()` */
  static readonly GetBookingsPath = '/api/admin/bookings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookings$Response(params: GetBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoBookingBookingDto>> {
    return getBookings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookings(params: GetBookings$Params, context?: HttpContext): Observable<PageDtoBookingBookingDto> {
    return this.getBookings$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoBookingBookingDto>): PageDtoBookingBookingDto => r.body)
    );
  }

  /** Path part for operation `getBooking()` */
  static readonly GetBookingPath = '/api/admin/bookings/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBooking$Response(params: GetBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return getBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBooking(params: GetBooking$Params, context?: HttpContext): Observable<BookingDto> {
    return this.getBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

  /** Path part for operation `getBookingLogs1()` */
  static readonly GetBookingLogs1Path = '/api/admin/bookings/{id}/logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingLogs1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingLogs1$Response(params: GetBookingLogs1$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoBookingLogBookingLogDto>> {
    return getBookingLogs1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingLogs1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingLogs1(params: GetBookingLogs1$Params, context?: HttpContext): Observable<PageDtoBookingLogBookingLogDto> {
    return this.getBookingLogs1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoBookingLogBookingLogDto>): PageDtoBookingLogBookingLogDto => r.body)
    );
  }

  /** Path part for operation `getBookingsWidgetTotal()` */
  static readonly GetBookingsWidgetTotalPath = '/api/admin/bookings/widget/total';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingsWidgetTotal()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingsWidgetTotal$Response(params: GetBookingsWidgetTotal$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingWidgetTotalDto>> {
    return getBookingsWidgetTotal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingsWidgetTotal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingsWidgetTotal(params: GetBookingsWidgetTotal$Params, context?: HttpContext): Observable<BookingWidgetTotalDto> {
    return this.getBookingsWidgetTotal$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingWidgetTotalDto>): BookingWidgetTotalDto => r.body)
    );
  }

  /** Path part for operation `getBookingsWidgetTimeline()` */
  static readonly GetBookingsWidgetTimelinePath = '/api/admin/bookings/widget/timeline';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingsWidgetTimeline()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingsWidgetTimeline$Response(params: GetBookingsWidgetTimeline$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingWidgetTimelineDto>> {
    return getBookingsWidgetTimeline(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingsWidgetTimeline$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingsWidgetTimeline(params: GetBookingsWidgetTimeline$Params, context?: HttpContext): Observable<BookingWidgetTimelineDto> {
    return this.getBookingsWidgetTimeline$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingWidgetTimelineDto>): BookingWidgetTimelineDto => r.body)
    );
  }

  /** Path part for operation `getBookingShareLogs1()` */
  static readonly GetBookingShareLogs1Path = '/api/admin/bookings/shares/{shareId}/logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingShareLogs1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShareLogs1$Response(params: GetBookingShareLogs1$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoBookingLogBookingLogDto>> {
    return getBookingShareLogs1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingShareLogs1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShareLogs1(params: GetBookingShareLogs1$Params, context?: HttpContext): Observable<PageDtoBookingLogBookingLogDto> {
    return this.getBookingShareLogs1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoBookingLogBookingLogDto>): PageDtoBookingLogBookingLogDto => r.body)
    );
  }

  /** Path part for operation `getActiveBooking()` */
  static readonly GetActiveBookingPath = '/api/admin/bookings/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveBooking()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveBooking$Response(params: GetActiveBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BookingDto>> {
    return getActiveBooking(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveBooking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveBooking(params: GetActiveBooking$Params, context?: HttpContext): Observable<BookingDto> {
    return this.getActiveBooking$Response(params, context).pipe(
      map((r: StrictHttpResponse<BookingDto>): BookingDto => r.body)
    );
  }

}
